export default __webpack_public_path__ + "static/media/fb_icon.dad7885c.svg";